import { createContext, useContext } from 'react';
import type { AuthResponse, User } from '@/api/types';

export type AuthStatus = 'loading' | 'authenticated' | 'anonymous';

export interface AuthValue {
  status: AuthStatus;
  user: User | null;
  signIn: (email: string, password: string) => Promise<AuthResponse>;
  signUp: (input: { email: string; password: string; name: string; timezone?: string }) => Promise<AuthResponse>;
  signOut: () => Promise<void>;
  /** Forget the session locally (after deleting the account). */
  clear: () => void;
}

export const AuthContext = createContext<AuthValue | null>(null);

export function useAuth(): AuthValue {
  const v = useContext(AuthContext);
  if (!v) throw new Error('useAuth outside AuthProvider');
  return v;
}
